module.exports = __webpack_public_path__ + "static/media/404.0de064c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/error/404.png
// module id = 136
// module chunks = 0